/*
 *  This document is the CONFIDENTIAL PROPERTY of Corero Network Security, Inc.
 *  Copyright (C) 2024-2024 by Corero Network Security, Inc. All rights reserved.
 *  Notice of copyright on this document does not constitute publication.
 */

if (!Array.prototype.contains) {// eslint-disable-next-line
    Array.prototype.contains = function () {
        return Array.prototype.indexOf.apply(this, arguments) !== -1;
    };
}

